import React, {useState} from 'react';
import { TickProvider } from "../../contexts/TickContext"; // Import TickProvider if needed
import ExchangeButtons from './ExchangeButtons'; // Assuming this component is already available

const SearchItemRow = ({ instrument, isExistingInGrid, handleAddPositionFromSearchBar, currentlyHeldPositions, setCurrentlyHeldPositions, tabID, tick,
                           PosGridlayouts,
                           setPosGridlayouts,
                           PosGridTabID }) => {

    const [isAdding, setIsAdding] = useState(false);

    const onAddClick = async () => {
        if (isExistingInGrid || isAdding) return;

        try {
            setIsAdding(true);

            await handleAddPositionFromSearchBar(
                instrument.instrumentToken,
                instrument,
                currentlyHeldPositions,
                setCurrentlyHeldPositions,   // still passed for compatibility with signature
                tabID,
                tick,
                setCurrentlyHeldPositions,
                PosGridlayouts,
                setPosGridlayouts,
                PosGridTabID
            );
        } catch (e) {
            console.error("Failed to add position from search bar", e);
        } finally {
            setIsAdding(false);
        }
    };

    return (
        <div className="tick-wrapper-trackedStocks">
            <TickProvider instrumentToken={instrument.instrumentToken}>
                <div
                    className="new-grid-item-st"
                    onClick={!isExistingInGrid && !isAdding ? onAddClick : undefined}
                    style={{
                        cursor: isExistingInGrid ? 'not-allowed' : 'pointer',
                        backgroundColor: isExistingInGrid ? '#E0E0E0' : 'transparent'
                    }}
                >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ display: 'inline-block', width: '20px' }}>
                            {isExistingInGrid && <span>✔</span>}
                        </span>
                    <span style={{ fontSize: '13px', width: '150px' }}>
                        {isExistingInGrid
                            ? `Already added`
                            : isAdding
                                ? `Adding ${instrument.tradingsymbol}...`
                                : instrument.tradingsymbol}
                    </span>

                        <span style={{ marginLeft: '20px', fontSize: '10px' }}>
                            {instrument.name}
                        </span>
                    </div>
                    <ExchangeButtons exchange={instrument.exchange} />
                </div>
            </TickProvider>
        </div>
    );
};

export default SearchItemRow;
